import type { ReactNode, SVGProps } from 'react'

export type IconName =
  | 'bell'
  | 'bell-off'
  | 'mic'
  | 'mic-off'
  | 'camera'
  | 'camera-off'
  | 'screen-share'
  | 'record'
  | 'chat'
  | 'users'
  | 'hand'
  | 'leave'
  | 'copy'
  | 'pencil'
  | 'settings'
  | 'close'
  | 'check'
  | 'plus'
  | 'chevron-down'
  | 'expand'
  | 'collapse'
  | 'camera-flip'
  | 'search'
  | 'menu'
  | 'log-out'
  | 'lock'
  | 'unlock'
  | 'eye'
  | 'eye-off'
  | 'filter'
  | 'chart'
  | 'calendar'
  | 'download'

const paths: Record<IconName, ReactNode> = {
  bell: (
    <>
      <path d="M6 9a6 6 0 0 1 12 0c0 4 1.5 5.5 2 6.5H4c.5-1 2-2.5 2-6.5z" />
      <path d="M10 18.5a2 2 0 0 0 4 0" />
    </>
  ),
  'bell-off': (
    <>
      <path d="M8.2 5A6 6 0 0 1 18 9c0 3 .8 4.6 1.5 5.7M6 9c0 4-1.5 5.5-2 6.5h12" />
      <path d="M10 18.5a2 2 0 0 0 4 0" />
      <path d="M4 4l16 16" />
    </>
  ),
  mic: (
    <>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
    </>
  ),
  'mic-off': (
    <>
      <path d="M9 9v-3a3 3 0 0 1 5.1-2.1M15 9.3V11M5 11a7 7 0 0 0 10.6 6M12 18v3" />
      <path d="M4 4l16 16" />
    </>
  ),
  camera: (
    <>
      <rect x="3" y="6" width="12" height="12" rx="2" />
      <path d="M15 10l6-3v10l-6-3z" />
    </>
  ),
  'camera-off': (
    <>
      <path d="M15 10l6-3v10l-3-1.5M11 6h2a2 2 0 0 1 2 2v2M3 8v8a2 2 0 0 0 2 2h8" />
      <path d="M4 4l16 16" />
    </>
  ),
  'screen-share': (
    <>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4M12 7v5M9.5 9.5L12 7l2.5 2.5" />
    </>
  ),
  record: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
    </>
  ),
  chat: <path d="M4 5h16v11H9l-4 3v-3H4z" />,
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0M16 5.2a3 3 0 0 1 0 5.6M18 20a6 6 0 0 0-3-5.2" />
    </>
  ),
  hand: (
    <path d="M8 13V5a1.5 1.5 0 0 1 3 0v6M11 11V4a1.5 1.5 0 0 1 3 0v7M14 11V6a1.5 1.5 0 0 1 3 0v8a6 6 0 0 1-6 6h-1a5 5 0 0 1-4-2l-3-4a1.6 1.6 0 0 1 2.4-2L8 13" />
  ),
  leave: <path d="M3 10.5c5-3.5 13-3.5 18 0v3l-3.5-.5-.5-2.5a12 12 0 0 0-10 0l-.5 2.5L3 13.5z" />,
  copy: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V5a2 2 0 0 1 2-2h8" />
    </>
  ),
  pencil: <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />,
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  check: <path d="M4 12l5 5L20 6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  'chevron-down': <path d="M6 9l6 6 6-6" />,
  expand: (
    <path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4" />
  ),
  collapse: (
    <path d="M9 4v4a1 1 0 0 1-1 1H4M15 4v4a1 1 0 0 0 1 1h4M9 20v-4a1 1 0 0 0-1-1H4M15 20v-4a1 1 0 0 1 1-1h4" />
  ),
  'camera-flip': (
    <>
      <path d="M4 10a8 8 0 0 1 13.7-3.7L20 8.5M20 14a8 8 0 0 1-13.7 3.7L4 15.5" />
      <path d="M20 4v4.5h-4.5M4 20v-4.5h4.5" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M16.5 16.5L21 21" />
    </>
  ),
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  'log-out': <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />,
  eye: (
    <>
      <path d="M3 12c0-2.5 4-7 9-7s9 4.5 9 7-4 7-9 7-9-4.5-9-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  'eye-off': (
    <>
      <path d="M3 3l18 18" />
      <path d="M10.6 5.2A9.9 9.9 0 0 1 12 5c5 0 9 4.5 9 7a12 12 0 0 1-2.5 3.4M6.4 6.6C4.2 8 3 10.1 3 12c0 2.5 4 7 9 7a9.6 9.6 0 0 0 4.1-.9" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </>
  ),
  lock: (
    <>
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </>
  ),
  filter: <path d="M21 4H3l7 8.5V19l4 2v-8.5L21 4z" />,
  chart: (
    <>
      <path d="M3 21h18" />
      <path d="M7 21V11M12 21V4M17 21v-7" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 10h18" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12M7 11l5 5 5-5" />
      <path d="M4 20h16" />
    </>
  ),
  // Дужка откинута вправо — открытый замок читается силуэтом, не только цветом.
  unlock: (
    <>
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 7.5-1.9" />
    </>
  ),
}

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName
  size?: number
}

export function Icon({ name, size = 20, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {paths[name]}
    </svg>
  )
}
